/// <reference path="./Entity.ts" />
/// <reference path="../HTML/Tag.ts" />
namespace HA.Core.Entity {
    import Tag = HA.Core.HTML.Tag;

    export class App extends Entity {

        public setLocalId(id: string): void {
            this.addToData("lid", id);
        }

        public getLocalId(): string {
            if (!this.has("lid")) {
                this.setLocalId( HA.Core.Entity.Entity.genId());
            }
            return this.get("lid");
        }

        public setPosition(position: number): void {
            this.addToData("_y", position);
        }

        public getPosition(): number {
            return this.get("_y") || 0;
        }

        private savePosition() {
            this.addToData("_y", window.scrollY);
        }

        public isNotCachable(): boolean {
            return !this.isCachable();
        }

        public isCachable(): boolean {
            return this.get("cachable");
        }

        public isViewed(): boolean {
            return this.get("viewed");
        }

        public setViewed(val: boolean): void {
            this.addToData("viewed", val);
        }

        public isNotNavigable(): boolean {
            return !this.isNavigable();
        }

        public isNavigable(): boolean {
            return this.get("navigable");
        }

        /**
         * @return {boolean}
         */
        public hasUrl() {
            return this.get("url") !== undefined;
        }

        public getUrl() {
            return this.get("url");
        }

        public getName() {
            return this.get("appTitle");
        }

        /**
         * @returns {Map<any, any>}
         */
        public getInfo() {
            const d = this.getTag().getAttributes(["appname", "apptitle"]);
            if (d && d.get("appname")) {
                return toMap({appName: d.get("appname"), appTitle: d.get("apptitle")});
            }
            return toMap({appTitle: this.get("appTitle"), appName: this.get("appName")});

        }

        public getQMenu(): Map<any, any> {
            let qm = this.get("qmenu");
            if (qm instanceof Map) {
                return qm;
            }

            qm = toMap(this.get("qmenu"));
            this.addToData("qmenu", qm);

            return qm;
        }

        /**
         *
         * @param controller
         * @returns {Map<String, any>}
         */
        protected setController(controller: any) {
            return this.addToData("controller", controller);
        }

        /**
         *
         * @returns {any}
         */
        protected getController() {
            return this.get("controller");
        }

        protected initialize(data: any) {
            super.initialize(data);
            if (!this.has("cachable")) {
                this.addToData("cachable", true);
            }
            if (!this.has("navigable")) {
                this.addToData("navigable", true);
            }
            if (this.has("fid")) {
                this.addToData("id", this.get("id") + this.get("fid"));
            }
            this.createTag(data);
            const controllerName = this.get("controllerName");

            if (controllerName) {
                const controllerNamespace = this.getControllerNamespace(this.get("controllerNamespace"));
                const cdata = toMap(this.getData());
                this.setController(createService(controllerNamespace, controllerName, cdata));
            }
            if (this.has("msg")) {
                log(this.get("msg"));
            }

            const animation = this.get("animation");

            if (typeof animation === "object") {
                this.addToData("animation", toMap(animation));
            }

            this.intro();
        }

        public outro(): void {
            this.savePosition();
            return;
            this.playAnimation("outro");
        }

        public intro(): void {
            timeout(() => {
                window.scrollTo(0, this.getPosition());
            }, 100);

            return;
            if (this.isViewed()) {
                return;
            }
            this.playAnimation("intro");
        }

        protected playAnimation(name: string): void {
            const animation = this.get("animation");
            if (!animation || !this.getTag()) {
                return;
            }
            const helper = {
                add: (classes: string | Map<any, string> | string[] | undefined) => {
                    if (!classes) {
                        return;
                    }
                    if (typeof classes === "string") {
                        this.getTag().addClass(classes);
                    } else if (classes) {
                        this.getTag().addClasses(classes);
                    }
                },
                remove: (classes: string | Map<any, string> | string[] | undefined) => {
                    if (!classes) {
                        return;
                    }
                    if (typeof classes === "string") {
                        this.getTag().removeClass(classes);
                    } else if (classes) {
                        this.getTag().removeClasses(classes);
                    }
                }
            };

            if (animation instanceof Map && animation.get(name)) {
                helper.add(animation.get(name));
                timeout(() => {
                    helper.remove(animation.get(name));
                }, 1000);
            } else if (typeof animation === "string") {
                helper.add(animation);
                timeout(() => {
                    helper.remove(animation);
                }, 3000);
            }
        }

        protected createTag(data: any) {
            this.addToData("tag", new Tag(data));
        }

        protected getControllerNamespace(name: string) {
            let n: any;
            switch (name) {
                case "HA.Core.Controller.Navigation" :
                    n = HA.Core.Controller.Navigation;
                    break;
                case "HA.Core.Controller.Menu" :
                    n = HA.Core.Controller.Menu;
                    break;
                case "HA.Core.Controller.Page" :
                    n = HA.Core.Controller.Page;
                    break;
                default :
                    n = HA.Core.Service;
                    break;
            }

            return n;
        }
    }
}
